import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ConfigurationService {
    private apiUrl = `${environment.apiConfig.uri}configurations`;

    constructor(private http: HttpClient) { }

    getMinimumPaymentPercentage(): Observable<number> {
        return this.http.get<number>(`${this.apiUrl}/minimum-payment-percentage`);
    }

    /** Passport expiration date limit in years (backoffice parameter PassportExpirationYears). */
    getPassportExpirationYears(): Observable<number> {
        return this.http.get<number>(`${this.apiUrl}/passport-expiration-years`);
    }
}
